export default {
  navbar: {
    home: "Nyumbani",
    roles: "Majukumu",
    features: "Vipengele",
    whyUs: "Kwa Nini Sisi",
    contactUs: "Wasiliana Nasi",
  },
  home: {
    TeachWings: "TeachWings",
    comprehensive: "Kamilifu",
    modules: "Moduli",
    for: "kwa",
    schoolManagement: "Usimamizi wa Shule",
    customized: "Imebinafsishwa",
    userAcees: "Ufikiaji wa Mtumiaji",
    heading_01: "Fly Juu na",
    how: "Jinsi",
    works: "Inafanya kazi",
    why_choose: "Kwa nini uchague",

    sub_heading_01: "Usimamizi wa Shule usio na bidii.",
    heading_02:
      "Mshirika wa Teknolojia Aliyeunganishwa kwa Mahitaji Yote ya Shule Yako",

    para_01:
      "Boresha jinsi shule yako inavyofanya kazi na TeachWings, suluhisho la usimamizi wa shule linalojumuisha yote. Imetengenezwa kutosheleza mahitaji ya wanafunzi, wazazi, walimu, na wasimamizi, TeachWings hurahisisha mawasiliano, kujifunza, na kazi za kiutawala, na kufanya shughuli za shule kuwa bora zaidi, wazi, na salama.",
    heading_03: "Kuhusu TeachWings",
    superAdmin: "Msimamizi Mkuu",
    admin: "Msimamizi",
    receptionist: "Mpokeaji",
    librarian: "Mkutubi",
    classTeacher: "Mwalimu wa Darasa",
    teacher: "Mwalimu",
    student: "Mwanafunzi",
    parent: "Mzazi",
    heading_04: "Kuhusu TeachWings",
    para_03:
      "TeachWings imejengwa kwa maono ya kurahisisha usimamizi wa shule na kuwawezesha wadau wote — wanafunzi, wazazi, walimu, na wasimamizi. Dhamira yetu ni kutoa jukwaa salama, rahisi kutumia ambalo linaimarisha mawasiliano, kuboresha ujifunzaji, na kuboresha kazi za kiutawala. Kwa TeachWings, tunasaidia shule duniani kote kupitisha teknolojia inayoboreshesha matokeo ya kielimu, kupunguza mzigo wa kiutawala, na kuimarisha mazingira ya kushirikiana. Hebu paa na TeachWings na uokoe muda.",
    heading_05: "Vipengele Muhimu vya TeachWings",

    card_heading_01: "Wasimamizi",
    card_heading_02: "Walimu",
    card_heading_03: "Wanafunzi",
    card_heading_04: "Wazazi",

    card_para_01:
      "Rahisisha udahili, simamia watumiaji, ratiba, ada, usafiri, na toa ripoti za kina kwa ufanisi wa shughuli na maamuzi ya busara.",
    card_para_02:
      "Simamia madarasa, fuatilia utendaji, toa alama, na ushirikiane kwa ufanisi.",
    card_para_03:
      "Pata alama, ratiba, kazi za nyumbani, mitihani, na rasilimali kwa urahisi.",
    card_para_04:
      "Kuwa na taarifa kuhusu maendeleo, mahudhurio, ada, na wasiliana bila shida.",

    keyFeatures: {
      list_01:
        "Usimamizi Kamili wa Watumiaji: Simamia walimu, wanafunzi, wafanyakazi, na wazazi kwa udhibiti kamili wa majukumu na ruhusa.",
      list_02: "Usimamizi wa Udahili Mpya na Kipindi cha Masomo",
      list_03:
        "Unda & Sasisha Ratiba: Rahisisha kuanzisha ratiba za madarasa, mitihani, na matukio ya shule.",
      list_04:
        "Usimamizi wa Ada na Fedha: Fuatilia fedha za shule, simamia miundo ya ada, na fuatilia malipo kwa ufanisi.",
      list_05:
        "Usimamizi wa Usafiri: Udhibiti wa usafiri huhakikisha uelekezaji, ufuatiliaji na ratiba ya mabasi kwa usafiri wa wanafunzi huku ukidumisha utiifu na usalama.",
      list_06:
        "Ripoti Zilizotegemea Takwimu: Tengeneza ripoti za kina na uchambuzi wa mahudhurio, utendaji, fedha, na zaidi.",
      list_07:
        "Simamia Madarasa na Kazi za Nyumbani: Panga madarasa, kazi za nyumbani, na mipango ya masomo yote mahali pamoja.",
      list_08:
        "Usimamizi wa Mahudhurio: Rekodi za mahudhurio ya darasa na ufuatiliaji.",
      list_09:
        "Fuatilia Maendeleo ya Wanafunzi: Tazama na fuatilia utendaji wa wanafunzi binafsi na toa maoni kwa wakati.",
      list_10:
        "Kitabu cha Alama na Ripoti: Ingiza alama haraka, tengeneza ripoti, na tathmini utendaji wa wanafunzi.",
      list_11:
        "Zana za Mawasiliano: Shirikiana moja kwa moja na wanafunzi na wazazi kupitia mfumo wa ujumbe uliojengwa ndani.",
      list_12:
        "Fuatilia Alama/Maandishi na Ripoti: Pata ufikiaji wa papo hapo wa alama zako, kazi za nyumbani, na masasisho ya utendaji.",
      list_13:
        "Tazama Ratiba na Ratiba ya Masomo: Usikose darasa lolote na ratiba yako ya kibinafsi na matukio yajayo.",
      list_14:
        "Kazi za Nyumbani na Kazi za Shule: Tazama na simamia kwa urahisi kazi zako za nyumbani na shule, ukijumuisha tarehe za mwisho na vikumbusho vya uwasilishaji.",
      list_15:
        "Sasisho za Mitihani na Matokeo: Kuwa na taarifa juu ya ratiba za mitihani na upate matokeo pindi yanapopatikana.",
      list_16:
        "Rasilimali za Kujifunza: Pata vifaa vya masomo vya kidijitali, mipango ya masomo, na maelezo kutoka kwa walimu wakati wowote, mahali popote.",
      list_17:
        "Fuatilia Alama/Maandishi na Ripoti: Pata ufikiaji wa papo hapo wa alama zako, kazi za nyumbani, na masasisho ya utendaji.",
      list_18:
        "Tazama Ratiba na Ratiba ya Masomo: Usikose darasa lolote na ratiba yako ya kibinafsi na matukio yajayo.",
      list_19:
        "Kazi za Nyumbani na Kazi za Shule: Tazama na simamia kwa urahisi kazi zako za nyumbani na shule, ukijumuisha tarehe za mwisho na vikumbusho vya uwasilishaji.",
      list_20:
        "Sasisho za Mitihani na Matokeo: Kuwa na taarifa juu ya ratiba za mitihani na upate matokeo pindi yanapopatikana.",
      list_21:
        "Rasilimali za Kujifunza: Pata vifaa vya masomo vya kidijitali, mipango ya masomo, na maelezo kutoka kwa walimu wakati wowote, mahali popote.",
    },

    heading_06: "Jinsi TeachWings Inavyofanya Kazi",
    card_heading_05: "Jisajili",
    card_heading_06: "Sanidi Wasifu Wako",
    card_heading_07: "Anza Kutumia Vipengele",
    card_heading_08: "Kaa Umeunganishwa",
    card_para_05: "Sajili shule yako na uchague usajili.",
    card_para_06:
      "Binafsisha dashibodi yako na sanidi mipangilio kulingana na jukumu lako na mapendeleo.",
    card_para_07:
      "Pata ufikiaji wa vipengele vyote muhimu — alama, kazi za nyumbani, zana za mawasiliano, ratiba, na zaidi mara moja.",
    card_para_08:
      "Pata masasisho ya papo hapo juu ya alama, mahudhurio, na habari za shule. Wasiliana moja kwa moja na walimu na wazazi, vyote ndani ya programu.",
    heading_07: "Kwa Nini Uchague TeachWings?",
    whyChoose: {
      list_01:
        "Shughuli za Shule Zilizorahisishwa: Simamia kila kitu kutoka kwa ratiba za madarasa na mahudhurio hadi alama na ada kwenye jukwaa moja, rahisi kutumia.",
      list_02:
        "Mawasiliano Yaliyoboreshwa: Kuwa na taarifa kwa kutumia arifa za papo hapo, ujumbe wa moja kwa moja, na masasisho ya haraka kwa watumiaji wote.",
      list_03:
        "Uchukuaji Wakati: Rahisisha kazi kama kuweka alama, kufuatilia mahudhurio, na vikumbusho vya ada, kukuruhusu kuzingatia kile kilicho muhimu zaidi — elimu.",
      list_04:
        "Salama na Faragha: Data yako iko salama nasi. TeachWings inazingatia viwango vya juu vya ulinzi wa data na faragha.",
      list_05:
        "Inayoweza Kubadilishwa kwa Shule Yako: Boresha jukwaa ili kuendana na mahitaji ya kipekee ya shule yako, na vipengele na mipangilio inayoweza kubadilishwa.",
    },
  },
  keyFeatures: {
    heading: {
      w1: "Key Features ",
      w2: "of TeachWings",
    },
    adminFeat: {
      h1: "Administrator",
    },
    teacherFeat: {
      h1: "Teachers",
    },
    studentFeat: {
      h1: "Students",
    },
    parentFeat: {
      h1: "Parents",
    },
  },
  contactUs: {
    heading_01: "Tuachie ujumbe au tuma barua pepe kwa",
    name: "Jina",
    email: "Barua pepe",
    contactNumber: "Nambari ya Mawasiliano",
    message: "Ujumbe",
    cancel: "Ghairi",
    submit: "Tuma",
  },
  readMore: {},
  common: {
    getStarted: "Anza",
    and: "na",
    registerNow: "Jisajili Sasa",
    loginNow: "Ingia Sasa",
    knowMore: "Jua Zaidi",
    learnMore: "Jifunze Zaidi",
  },

  footer: {
    availableOn: "Inapatikana kwenye",
    contactEnquiry: "Mawasiliano / Uchunguzi",
    navigate: "Vinjari",
    usefullLinks: "Viungo Muhimu",
    footer_para:
      "Una maswali au unahitaji msaada? Wasiliana nasi kwa maelezo zaidi au demo.",
    allRightsReserved: "Haki zote zimehifadhiwa.",
    playStore: "Duka la Google Play",
    home: "Nyumbani",
    features: "Vipengele",
    whyUs: "Kwa Nini Sisi",
    contactUs: "Wasiliana Nasi",
    appStore: "Duka la App",
    register: "Jisajili",
    login: "Ingia",
  },

  privacy: {
    h1: "Privacy Policy",
  },
};
